export enum WEB_SOCKET_EMIT {
  NEW_USER = 'dime-create-user',
  UPDATE_USER = 'dime-update-user',
  NEW_INCIDENT = 'dime-create-incident',
}

export enum WEB_SOCKET_RECEIVE {
  NEW_USER = 'dime-created-user',
  UPDATE_USER = 'dime-updated-user',
  NEW_INCIDENT = 'dime-created-incident',
  MESSAGE_CREATED = 'dime-message-created',
}
